module.exports = __webpack_public_path__ + "img/icon-rts-en.5856eb1c.svg";